import React from 'react';
import { ThemeProvider } from '@workboard/wobo-ui';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import styled from 'styled-components';
import TeamLandingHeader from './TeamLandingHeader';
import TeamsTable from './TeamsTable';
import { BREAKPOINTS } from './styles/styles';

const TeamContainer = styled.div`
  display: block;
  margin: 40px 72px 72px;
`;

const LandingPage = (): JSX.Element => {
  const maxWidthIs720 = useMediaQuery(BREAKPOINTS.sm);
  const maxWidthIs980 = useMediaQuery(BREAKPOINTS.lg);
  const maxWidth = maxWidthIs980
    ? { display: 'block', margin: '32px 24px 72px' }
    : { display: 'block', margin: '32px 72px 72px' };
  return (
    <ThemeProvider>
      <TeamContainer
        className="team-landing-page-container"
        style={
          maxWidthIs720
            ? { display: 'block', margin: '32px 16px 72px' }
            : maxWidth
        }
      >
        <TeamLandingHeader />
        <TeamsTable />
      </TeamContainer>
    </ThemeProvider>
  );
};

export default LandingPage;
